export const PLACEHOLDER_IMAGE =
  "https://cdn.shopify.com/s/files/1/0409/5754/2562/files/ES_Logo_-_2k_-_Lossy.png?v=1658252729";
